import React, { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { Lock, Check, Loader2 } from "lucide-react";
import { useApp } from "../context/AppContext";
import { startCheckout } from "../lib/api";
import { toast } from "sonner";

const PERKS = [
  "Unlimited Ask-the-Council sessions",
  "Unlimited Insight Worksheets",
  "No ads, no subscriptions — ever",
  "One-time payment of $5.00",
];

export function Paywall({ open, onOpenChange }) {
  const { clientId } = useApp();
  const [loading, setLoading] = useState(false);

  const buy = async () => {
    setLoading(true);
    try {
      const { checkout_url } = await startCheckout(clientId);
      window.location.href = checkout_url;
    } catch (e) {
      toast.error("Could not start checkout. Please try again.");
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md rounded-2xl border p-0 overflow-hidden" style={{ borderColor: "#CBD5E1" }}>
        <div className="p-8" data-testid="paywall-modal">
          <DialogTitle className="sr-only">Unlock Acuman</DialogTitle>
          <div className="grid place-items-center w-14 h-14 rounded-2xl mb-5" style={{ background: "#EFF6FF" }}>
            <Lock size={26} color="#2563EB" />
          </div>
          <h2 className="text-2xl font-black tracking-tight" style={{ color: "#1E293B" }}>
            You've used your 5 free sessions
          </h2>
          <p className="mt-2 text-base leading-relaxed" style={{ color: "#475569" }}>
            Unlock Acuman forever with a single one-time payment. No subscriptions, no surprises.
          </p>
          <ul className="mt-6 space-y-3">
            {PERKS.map((p) => (
              <li key={p} className="flex items-start gap-3 text-sm" style={{ color: "#334155" }}>
                <span className="grid place-items-center w-5 h-5 rounded-full mt-0.5" style={{ background: "#10B981" }}>
                  <Check size={13} color="#fff" />
                </span>
                {p}
              </li>
            ))}
          </ul>
          <button onClick={buy} disabled={loading} data-testid="unlock-buy-btn"
            className="mt-7 w-full h-12 rounded-xl font-bold text-white flex items-center justify-center gap-2 transition-colors duration-200 disabled:opacity-70"
            style={{ background: "#2563EB" }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#1D4ED8")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#2563EB")}>
            {loading ? <Loader2 size={18} className="animate-spin" /> : null}
            {loading ? "Redirecting…" : "Unlock forever — $5.00"}
          </button>
          <p className="text-xs text-center mt-3" style={{ color: "#94A3B8" }}>
            Secure checkout via Stripe. Test card 4242 4242 4242 4242.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
